module.exports = __webpack_public_path__ + "static/media/receiptSecondPage.9a5d3e76.png";